module.exports = __webpack_public_path__ + "static/media/bell.f4356c27.svg";